import React from "react";
import ReactDOM from "react-dom/client";
import "./polyfills"; // Load polyfills first for older iOS Safari compatibility
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "react-notifications/lib/notifications.css";
import { UserProvider } from "./context/UserContext";
import { UploadProvider } from "./context/UploadContext";
import { NotificationContainer } from "react-notifications";
import GlobalUploadLoader from "./components/Utils/GlobalUploadLoader";
import CookieBanner from "./components/Utils/CookieBanner";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <UserProvider>
    <UploadProvider>
      <GlobalUploadLoader />
      <App />
      <NotificationContainer />
      <CookieBanner />
    </UploadProvider>
  </UserProvider>,
);
